import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Dashboard1 from "./Dashboard1";
import { hasRoleAccess, ADMIN_DASHBOARD_RULE, homePathForRoles } from "../../../utils/roleAccess";

// /dashboard = tableau de bord de l'administration. Un enseignant ou un
// étudiant qui arrive ici (page d'accueil par défaut, ancien lien) est
// redirigé vers SON tableau de bord.
const DashboardRouter = () => {
  const roles = useSelector((state) => state.auth.auth?.user?.roles) || [];
  if (hasRoleAccess(ADMIN_DASHBOARD_RULE, roles)) return <Dashboard1 />;
  return <Navigate to={homePathForRoles(roles)} replace />;
};

export default DashboardRouter;
